var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { BaseTransition } from './BaseTransition';
import { useTransitionConfig, useTransitionTimeout } from './hooks';
import { scale } from './effects';
export function ScaleTransition(_a) {
    var _b = _a.from, from = _b === void 0 ? 0.5 : _b, _c = _a.to, to = _c === void 0 ? from : _c, timeout = _a.timeout, origin = _a.origin, rest = __rest(_a, ["from", "to", "timeout", "origin"]);
    var _d = useTransitionConfig(), transitionPrefix = _d.transitionPrefix, timingFunction = _d.timingFunction;
    var _e = useTransitionTimeout({ timeout: timeout }), enterTimeout = _e.enterTimeout, exitTimeout = _e.exitTimeout;
    var scaleProps = useMemo(function () {
        return scale({
            transitionPrefix: transitionPrefix,
            timingFunction: timingFunction,
            enterTimeout: enterTimeout,
            exitTimeout: exitTimeout,
            enterScale: from,
            exitScale: to,
            origin: origin,
        });
    }, [transitionPrefix, timingFunction, enterTimeout, exitTimeout, from, to, origin]);
    return React.createElement(BaseTransition, __assign({}, scaleProps, rest));
}
